var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skin-blue",attrs:{"id":"main-wrapper"}},[_c('b-overlay',{attrs:{"show":_vm.loadingOverlay,"rounded":"sm"}},[_c('bo-header'),_c('bo-sidebar'),_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1),_c('bo-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }